module.exports = __webpack_public_path__ + "static/media/map-and-achievements.e23d6cf9.png";